/*! modernizr 3.2.0 (Custom Build) | MIT *
 * http://modernizr.com/download/?-cssvmaxunit-setclasses ! */
!(function (e, n, t) {
  function o(e, n) {
    return typeof e === n;
  }
  function s() {
    let e;
    let n;
    let t;
    let s;
    let i;
    let a;
    let r;
    for (const l in c) {
      if (c.hasOwnProperty(l)) {
        if (
          ((e = []),
          (n = c[l]),
          n.name &&
            (e.push(n.name.toLowerCase()),
            n.options && n.options.aliases && n.options.aliases.length))
        )
          for (t = 0; t < n.options.aliases.length; t++)
            e.push(n.options.aliases[t].toLowerCase());
        for (
          s = o(n.fn, "function") ? n.fn() : n.fn, i = 0;
          i < e.length;
          i++
        ) {
          (a = e[i]),
            (r = a.split(".")),
            r.length === 1
              ? (Modernizr[r[0]] = s)
              : (!Modernizr[r[0]] ||
                  Modernizr[r[0]] instanceof Boolean ||
                  (Modernizr[r[0]] = new Boolean(Modernizr[r[0]])),
                (Modernizr[r[0]][r[1]] = s)),
            f.push((s ? "" : "no-") + r.join("-"));
        }
      }
    }
  }
  function i(e) {
    let n = u.className;
    const t = Modernizr._config.classPrefix || "";
    if ((h && (n = n.baseVal), Modernizr._config.enableJSClass)) {
      const o = new RegExp(`(^|\\s)${t}no-js(\\s|$)`);
      n = n.replace(o, `$1${t}js$2`);
    }
    Modernizr._config.enableClasses &&
      ((n += ` ${t}${e.join(` ${t}`)}`),
      h ? (u.className.baseVal = n) : (u.className = n));
  }
  function a(e, n) {
    return e - 1 === n || e === n || e + 1 === n;
  }
  function r() {
    return typeof n.createElement !== "function"
      ? n.createElement(arguments[0])
      : h
      ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0])
      : n.createElement.apply(n, arguments);
  }
  function l() {
    let e = n.body;
    return e || ((e = r(h ? "svg" : "body")), (e.fake = !0)), e;
  }
  function d(e, t, o, s) {
    let i;
    let a;
    let d;
    let f;
    const c = "modernizr";
    const p = r("div");
    const h = l();
    if (parseInt(o, 10))
      for (; o--; )
        (d = r("div")), (d.id = s ? s[o] : c + (o + 1)), p.appendChild(d);
    return (
      (i = r("style")),
      (i.type = "text/css"),
      (i.id = `s${c}`),
      (h.fake ? h : p).appendChild(i),
      h.appendChild(p),
      i.styleSheet
        ? (i.styleSheet.cssText = e)
        : i.appendChild(n.createTextNode(e)),
      (p.id = c),
      h.fake &&
        ((h.style.background = ""),
        (h.style.overflow = "hidden"),
        (f = u.style.overflow),
        (u.style.overflow = "hidden"),
        u.appendChild(h)),
      (a = t(p, e)),
      h.fake
        ? (h.parentNode.removeChild(h), (u.style.overflow = f), u.offsetHeight)
        : p.parentNode.removeChild(p),
      !!a
    );
  }
  var f = [];
  var c = [];
  const p = {
    _version: "3.2.0",
    _config: {
      classPrefix: "",
      enableClasses: !0,
      enableJSClass: !0,
      usePrefixes: !0,
    },
    _q: [],
    on(e, n) {
      const t = this;
      setTimeout(() => {
        n(t[e]);
      }, 0);
    },
    addTest(e, n, t) {
      c.push({ name: e, fn: n, options: t });
    },
    addAsyncTest(e) {
      c.push({ name: null, fn: e });
    },
  };
  var Modernizr = function () {};
  (Modernizr.prototype = p), (Modernizr = new Modernizr());
  var u = n.documentElement;
  var h = u.nodeName.toLowerCase() === "svg";
  const m = (p.testStyles = d);
  m(
    "#modernizr1{width: 50vmax}#modernizr2{width:50px;height:50px;overflow:scroll}#modernizr3{position:fixed;top:0;left:0;bottom:0;right:0}",
    (n) => {
      const t = n.childNodes[2];
      const o = n.childNodes[1];
      const s = n.childNodes[0];
      const i = parseInt((o.offsetWidth - o.clientWidth) / 2, 10);
      const r = s.clientWidth / 100;
      const l = s.clientHeight / 100;
      const d = parseInt(50 * Math.max(r, l), 10);
      const f = parseInt(
        (e.getComputedStyle ? getComputedStyle(t, null) : t.currentStyle).width,
        10
      );
      Modernizr.addTest("cssvmaxunit", a(d, f) || a(d, f - i));
    },
    3
  ),
    s(),
    i(f),
    delete p.addTest,
    delete p.addAsyncTest;
  for (let v = 0; v < Modernizr._q.length; v++) Modernizr._q[v]();
  e.Modernizr = Modernizr;
})(window, document);
